import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Step4 } from '../../../../shared/models/component-messages/simp_in/step4';
import { TypeMontant } from '../models/TypeMontant';
import { SimpINControlNames } from '../simpINControleNames';
import { CTRL_2003 } from '../../../validators/newRG/2003/ctrl2003';
@Component({
	selector: 'app-type-montant',
	templateUrl: './type-montant.component.html'
})
export class TypeMontantComponent implements OnInit {
	@Input() uid = '';
	public current_uid = 'TypeMontant';
	@Input() parentForm: FormGroup;
	
	@Input() disabled: boolean;
	@Input() estimationValeur: TypeMontant;
	@Input()i=0;

	public step4 = new Step4();

	public rg1 = CTRL_2003.id + '_1_';
	public rg2 = CTRL_2003.id + '_2_';

	constructor() {}

	public ngOnInit() {
		this.parentForm.addControl(this.getStepId() + this.rg1 + this.i, new FormControl({ rgCtrls: SimpINControlNames.getCtrl_2003_1Names_json(this.i+1) }));
		this.parentForm.addControl(this.getStepId() + this.rg2 + this.i, new FormControl({ rgCtrls: SimpINControlNames.getCtrl_2003_2Names_json(this.i+1) }));
	}

	getUid() {
		return this.uid + '_SepSep_' + this.current_uid;
	}

	getStepId() {
        return this.uid.substring(0, this.uid.indexOf("SepSep"));
    }
}
